<template>
  <div>
    <div class="title">您正在申请变更证券账户信息，为确认您的身份，请输入证券账户密码：</div>
    <van-field
      v-model="password"
      placeholder="请输入密码"
      type="password"
      clearable
      :error-message="passwordError"
      @input="validatePassword"
    >
    </van-field>
    <van-button type="primary" @click="submit" style="width: 80%; margin: 20px auto 20px auto">
      确定
    </van-button>
    <div style="text-align: center">
      <a
        @click="this.$router.push({ name: 'password_forget' })"
        style="font-size: 14px; color: #1989fa"
      >
        忘记密码
      </a>
    </div>
  </div>
</template>

<script>
import { Button, Image, Field, CellGroup, Icon, Toast } from "vant";
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import httpApi from "../../utils/httpApi";

export default {
  name: "verify",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Icon.name]: Icon,
  },
  data() {
    return {
      password: "",
      passwordError: "",
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    validatePassword() {
      if (!this.password) {
        this.passwordError = "请输入密码";
      } else {
        this.passwordError = "";
      }
    },
    async submit() {
      this.validatePassword();
      if (this.passwordError) {
        return;
      }
      // 这里实现密码验证逻辑
      const nextUrl = this.$route.query.next_url || this.$route.query.nextUrl || "";
      // 假设验证成功后跳转到nextUrl
      const res = await httpApi.passwordLogin({
        password: this.password,
      });
      if (res.code === 200) {
        Toast("密码验证成功");
        if (nextUrl) {
          this.$router.push(nextUrl);
        } else {
          this.$router.back();
        }
      } else {
        Toast(res.msg || "密码验证失败，请重试");
      }
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    onMounted(async () => {
      store.commit("setTitleValue", "身份认证");
    });
    return { route };
  },
};
</script>

<style lang="less">
/* 身份认证页面样式 */
.title {
  color: @font-color-0;
  font-size: @font-size-2;
  padding-left: @space-2;
  padding-right: @space-2;
  padding-top: @space-4;
  padding-bottom: @space-4;
  text-align: left;
}
</style>
